export default "__VITE_ASSET__DMhkK91m__"